import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { Divider, Box, Typography } from '@mui/material';
import { actions } from '../../../../redux/reducers/prescriptionReducer';
import Websites from './websites';
import WebsitesSekeleton from './websitesSkeleton';

const topWebsites = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { dtcData } = useSelector((state)=> state.webMatrix);
    const { topWebsitesData, isTopWebsitesLoading } = dtcData;

    const renderNoWebsite = () => (
        <Typography className="text-sm-regular gray-900">
                No Websites list to display
        </Typography>
    );
    const renderPrescriber = () => topWebsitesData && topWebsitesData.length > 0 ? (<Box>
        {topWebsitesData.map((topWebsite, index) => (
            <Box className='br-10px bg-white' key={'website-container'+uuidv4()}>
                <Websites
                    key={'website'+topWebsite?.website}
                    website={topWebsite}
                />
            </Box>
        ))}
    </Box>) : renderNoWebsite();

    return (
        <>
            <Box className="top-prescriber-container">
                <Box className="flex-row-space-between">
                    <Box>
                        <Typography className="text-md-medium gray-900">
                            Top Sites
                        </Typography>
                    </Box>
                </Box>
                <Divider className="mt-12px mb-24px border-1-gray" />
                { isTopWebsitesLoading ? Array.from({ length: 8 }).map((_, index) => <WebsitesSekeleton key={'prescriber-skeleton'+index} />) : renderPrescriber() }
            </Box>
        </>
    );
};

export default topWebsites;
